module.exports = __webpack_public_path__ + "img/repair_kit.909bdf77.png";